module.exports = __webpack_public_path__ + "static/Inlays-49db6d9a84791edf347aace948edfa08.jpg";